module.exports = __webpack_public_path__ + "img/Send-money-3.c19e4d3d.png";